import React from "react";

const OrderSmallSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        fill="#000"
        d="M5.923.379a3 3 0 012.154 0l4.962 1.908a1.5 1.5 0 01.961 1.4v6.626a1.5 1.5 0 01-.961 1.4l-4.962 1.909a3 3 0 01-2.154 0l-4.961-1.91a1.5 1.5 0 01-.962-1.4V3.688a1.5 1.5 0 01.962-1.4L5.923.379zm1.795.933a2 2 0 00-1.436 0l-1.384.533 5.59 2.116 1.948-.834L7.718 1.31zM13 3.972L7.5 6.33v6.428c.074-.02.146-.042.218-.07l4.962-1.908a.5.5 0 00.32-.467V3.972zm-6.5 8.786V6.33L1 3.973v6.34a.5.5 0 00.32.467l4.962 1.908c.072.028.144.05.218.07zM1.564 3.127L7 5.457l2.164-.928-5.667-2.146-1.933.744z"
      ></path>
    </svg>
  );
};

export default OrderSmallSVG;
